import React from 'react';
import s from './styles.module.css.json';
export function FieldError(_a) {
    var children = _a.children;
    return React.createElement("div", { className: s.fieldError }, children);
}
//# sourceMappingURL=index.js.map